import * as UI from '@brewlogix/blx-ui'
import * as CC from '@chakra-ui/react'
import React from 'react'
import { Location } from 'src/types/schema/graphql'
import CardHeader from '../../../../components/cards/CardHeader'
import { mapStore } from '../../state/mapStore'

interface ILocationPopupCard {
    location: Location
    type: 'MapboxProperties' | 'Location'
}

const LocationPopupCard: React.FC<ILocationPopupCard> = ({ location }) => {
    const setHoveredLocationCard = mapStore((state) => state.setHoveredLocationCard)
    const handleCardClick = () =>
        window.open(`/brewer/${location?.brand?.slug}/locations/${location.slug}`, '_ blank')

    const handleMouseEnter = () => setHoveredLocationCard(location.id)

    const handleMouseLeave = () => setHoveredLocationCard(null)

    return (
        <CC.Card
            className='card card--default card--location w-full cursor-pointer p-0 duration-200 ease-in-out hover:bg-gray-50'
            mb='4'
            onClick={handleCardClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <CC.CardBody w='100%' p='4'>
                {location?.assets?.length > 0 && process.env.NEXT_PUBLIC_SHOW_LOCATION_IMAGES && (
                    <UI.Media
                        asset={location.assets[0]}
                        customClasses='w-full h-full mb-4 rounded-md'
                        width={350}
                        height={200}
                        alt={`Logo for ${location?.title}`}
                    />
                )}
                <CardHeader location={location} type='popup' />
            </CC.CardBody>
        </CC.Card>
    )
}
export default React.memo(LocationPopupCard)
